import { Action } from '../../../shared/xs/actions';

export class StartCo2CalculationAction implements Action {
  static readonly type = '[Co2Calculator] Start new CO2 calculation';
}
